import {
  useMutation,
  useQueryClient,
  UseMutationOptions,
} from '@tanstack/react-query';
import { ReadAudience, PatchAudience } from '@tinct/core-api-models';
import { ApiError, tinctApi } from '../../api';

export interface PatchAudienceParams {
  id: string;
  data: PatchAudience;
}

export const patchAudience = async (params: PatchAudienceParams): Promise<ReadAudience> => {
  return await tinctApi.audiences.patchAudience(params.id, params.data);
};

export const usePatchAudience = (
  options?: Omit<
    UseMutationOptions<ReadAudience, ApiError, PatchAudienceParams>,
    'mutationFn'
  >,
) => {
  const { onSuccess, ...restOptions } = options || {};
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: patchAudience,
    onSuccess: (...args) => {
      queryClient.invalidateQueries({ queryKey: ['audiences'] });
      queryClient.invalidateQueries({ queryKey: ['audience', args[1].id] });
      if (args[0].organization) {
        queryClient.invalidateQueries({ queryKey: ['organization', args[0].organization.id] });
      }
      onSuccess?.(...args);
    },
    ...restOptions,
  });
};
